import { memo } from "react";
function Icon3PL({ color = "#808080" }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.53101 7.38526H2.90237L0.666626 9.61593V12.6502H2.35991M12.4525 12.6273C12.4913 12.4895 12.512 12.3441 12.512 12.1939C12.512 11.3119 11.797 10.5969 10.915 10.5969C10.0331 10.5969 9.31808 11.3119 9.31808 12.1939C9.31808 12.3441 9.33883 12.4895 9.37761 12.6273M12.4525 12.6273C12.2636 13.2987 11.6468 13.7908 10.915 13.7908C10.1833 13.7908 9.56651 13.2987 9.37761 12.6273M12.4525 12.6273H14V5.33203H12M9.37761 12.6273H5.53101V5.33203H7.33329M5.41694 12.1939C5.41694 13.0759 4.70196 13.7908 3.81998 13.7908C2.93801 13.7908 2.22303 13.0759 2.22303 12.1939C2.22303 11.3119 2.93801 10.5969 3.81998 10.5969C4.70196 10.5969 5.41694 11.3119 5.41694 12.1939Z"
        stroke={color}
        strokeWidth="1.1"
      />
      <path
        d="M10.5534 5.59412C10.5534 5.83719 10.4805 6.04388 10.3347 6.21421C10.1888 6.38454 9.98419 6.50164 9.72069 6.56551V6.58148C10.0316 6.62051 10.267 6.71632 10.4269 6.8689C10.5867 7.01971 10.6667 7.22375 10.6667 7.48101C10.6667 7.85537 10.5323 8.14723 10.2635 8.35659C9.99473 8.56418 9.61089 8.66797 9.11199 8.66797C8.6939 8.66797 8.32323 8.59789 8 8.45772V7.75779C8.14932 7.83408 8.31357 7.89618 8.49275 7.94408C8.67194 7.99199 8.84936 8.01594 9.02503 8.01594C9.29381 8.01594 9.49231 7.96981 9.62055 7.87755C9.74879 7.78529 9.81291 7.63714 9.81291 7.43311C9.81291 7.25036 9.73913 7.12084 9.59157 7.04455C9.44401 6.96826 9.20861 6.93011 8.88538 6.93011H8.59289V6.29937H8.89065C9.18928 6.29937 9.40711 6.26034 9.54414 6.18227C9.68292 6.10243 9.75231 5.9667 9.75231 5.77509C9.75231 5.48057 9.56961 5.3333 9.20422 5.3333C9.07773 5.3333 8.94862 5.3546 8.81686 5.39718C8.68687 5.43976 8.54194 5.51339 8.38208 5.61807L8.00527 5.0512C8.35661 4.79571 8.77558 4.66797 9.26219 4.66797C9.66096 4.66797 9.97541 4.74958 10.2055 4.91281C10.4374 5.07604 10.5534 5.30314 10.5534 5.59412Z"
        fill={color}
      />
    </svg>
  );
}

export default memo(Icon3PL);



